export default ({ user }) => `${user.lastName || ''} ${user.firstName || ''} ${user.middleName || ''}`;
